import React, { useEffect } from 'react';
import { UrgencyStrip } from './components/UrgencyStrip';
import { HeroSection } from './components/HeroSection';
import { PainAgitation } from './components/PainAgitation';
import { HowItWorks } from './components/HowItWorks';
import { MechanismReveal } from './components/MechanismReveal';
import { FeaturedTestimonial } from './components/FeaturedTestimonial';
import { TestimonialCarousel } from './components/TestimonialCarousel';
import { CreatorSection } from './components/CreatorSection';
import { BonusStack } from './components/BonusStack';
import { OfferStack } from './components/OfferStack';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { FAQBlock } from './components/FAQBlock';
import { initMetaPixel } from './utils/metaPixel';
import { captureTrackingParams } from './utils/utmParams';
export function App() {
  useEffect(() => {
    captureTrackingParams();
    initMetaPixel();
  }, []);
  return <>
      <UrgencyStrip data-id="element-0" />
      <div className="min-h-screen w-full bg-cream font-sans pt-10 md:pt-9" data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainAgitation data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <MechanismReveal data-id="element-5" />
        <FeaturedTestimonial data-id="element-6" />
        <TestimonialCarousel data-id="element-7" />
        <CreatorSection data-id="element-8" />
        <BonusStack data-id="element-9" />
        <OfferStack data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQBlock data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </div>
    </>;
}